module.exports = __webpack_public_path__ + "static/img/tn_DSC_1710_1920x1440.587531a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slider/tn_DSC_1710_1920x1440.jpg
// module id = B4NI
// module chunks = 1